import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_COURSE_BOOKING_INFO = gql`
  query BookableFullCourse($courseId: ID!) {
    bookableFullCourse(courseId: $courseId) {
      id
      title
      remainingLessons {
        topic {
          ...TopicBasicFields
        }
      }
      remainingCourseCost
      remainingStudentCredit
      remainingAmountAfterBooking
      bookable
      overlappedLessons {
        topic {
          ...TopicBasicFields
        }
        startTime
      }
      fullSeatLessons {
        topic {
          ...TopicBasicFields
        }
        startTime
      }
      emptyIncomingLessons {
        topic {
          ...TopicBasicFields
        }
        startTime
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_COURSE_BOOKING_INFO;
